import {Tabs} from 'antd';
import {PlantStageType} from "../../api/Constants";
import {CloneTab} from "./CloneTab";
import {HarvestedPlants} from "./HarvestedPlants";

export const HarvestTab = ({room, roomMap, onApiFail, session, refresh, onRefresh, props}) => {
    const items = [
        {
            key: 'CurrentPlants',
            label: 'Current Plants',
            children: <CloneTab session={session} room={room} stage={PlantStageType.Harvest} roomMap={roomMap} refresh={refresh} onRefresh={onRefresh} onApiFail={onApiFail} />
        },
        {
            key: 'Harvest',
            label: 'Harvest',
            children: <HarvestedPlants session={session} room={room} refresh={refresh} onRefresh={onRefresh} onApiFail={onApiFail} />
        }
    ]

    return <Tabs tabPosition={'left'} defaultActiveKey={'CurrentPlants'} items={items} />
}